"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../baseSchema");
const baseClickSchema_1 = require("../baseSchema/baseClickSchema");
class ClickDeleteContentSchema extends baseClickSchema_1.BaseClickSchema {
    constructor({ errorCode, success, componentName }) {
        super({ componentName });
        this.action = baseSchema_1.ActionsName.CLICK_DELETE_CONTENT;
        this.errorCode = errorCode;
        this.success = success;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            errorCode: this.errorCode,
            success: this.success
        };
    }
}
exports.default = ClickDeleteContentSchema;
